import { ReportsSharedModule } from './reports-shared.module';
import { GridsterModule } from 'angular-gridster2';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationService, MessageService } from "primeng/api";
import { ContextMenuModule } from 'primeng/contextmenu';


import { PrimngDesignModule } from '../modules/primng-design/primng-design.module';
import { SharedComponentModule } from '../modules/shared/shared.module';
import { ReportsComponent } from './reports.component';
import { Template1Component } from './fsm/template/template1/template1.component';
import { Template2Component } from './fsm/template/template2/template2.component';
import { Template3Component } from './fsm/template/template3/template3.component';
import { Template4Component } from './fsm/template/template4/template4.component';
import { Template5Component } from './fsm/template/template5/template5.component';
import { Template6Component } from './fsm/template/template6/template6.component';

import { QByChannelComponent } from './fsm/q-by-channel/q-by-channel.component';
import { LoginComponent } from './login/login.component';
import { FinanceComponent } from './finance/finance.component';
import { ActivityReportsComponent } from './components/activity-reports/activity-reports.component';
import { ReportsRoutingModule } from './reports-routing.module';
import { ReportsQuestionaireComponent } from './components/reports-questionaire/reports-questionaire.component';
import { ReportsLoginComponent } from './components/reports-login/reports-login.component';
import { ReportsFinanceComponent } from './components/reports-finance/reports-finance.component';
import { ReportsInventoryComponent } from './components/reports-inventory/reports-inventory.component';
import { AccountReportsComponent } from './components/account-reports/account-reports.component';
import { CaseReportsComponent } from './components/case-reports/case-reports.component';
import { DataService } from './dataService';
import { ReportsTemplatesComponent } from './components/reports-templates/reports-templates.component';
import { SettingComponent } from './setting/setting.component';
import { SalesOrderModule } from '../inventory/sales-order/sales-order.module';
import { ReportsUserActivityComponent } from './components/reports-user-activity/reports-user-activity.component';
import { ReportsAuditComponent } from './components/reports-audit/reports-audit.component';
import { SavedSearchReportComponent } from './components/saved-search-report/saved-search-report.component';

@NgModule({
    declarations: [
        ReportsComponent,


        Template1Component,
        Template2Component,
        Template3Component,
        Template4Component,
        Template5Component,
        Template6Component,

        QByChannelComponent,
        LoginComponent,
        FinanceComponent,
        ReportsQuestionaireComponent,
        ReportsLoginComponent,
        ReportsFinanceComponent,
        ReportsInventoryComponent,
        ActivityReportsComponent,
        AccountReportsComponent,
        CaseReportsComponent,
        ReportsTemplatesComponent,
        SettingComponent,
        ReportsUserActivityComponent,
        ReportsAuditComponent,
        SavedSearchReportComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ContextMenuModule,
        SharedComponentModule,
        PrimngDesignModule,
        ReportsRoutingModule,
        GridsterModule,
        SalesOrderModule,
        ReportsSharedModule
    ],
    exports: [

    ],
    providers: [ConfirmationService, MessageService, DataService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],

})
export class ReportsModule { }
